import script from "./ChatTextMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatTextMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatTextMessage.vue?vue&type=style&index=0&id=be7468b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be7468b2"]])

export default __exports__